import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

import { ZXComponent } from 'src/app/models/component';

interface ActivityOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-create-activity-dialog',
  templateUrl: './create-activity-dialog.component.html',
  styleUrls: ['./create-activity-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
  ],
})
export class CreateActivityDialogComponent {
  selectedActivity: string;
  activityDateTime: string;
  minDateTime: string;

  activityOptions: ActivityOption[] = [{ value: 'inspect', label: 'Inspect' }];

  constructor(
    public dialogRef: MatDialogRef<CreateActivityDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { component: ZXComponent }
  ) {
    if (data.component.deviceIdentifier) {
      this.activityOptions.push({ value: 'batteryChange', label: 'Battery Change' });
    }
    const now = new Date();
    const oneYearAgo = new Date(now);
    oneYearAgo.setFullYear(now.getFullYear() - 1);
    this.activityDateTime = now.toISOString().slice(0, 16);
    this.minDateTime = data.component.createdAt
      ? new Date(data.component.createdAt).toISOString().slice(0, 16)
      : oneYearAgo.toISOString().slice(0, 16);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.selectedActivity && this.activityDateTime) {
      const dateTime = new Date(this.activityDateTime + 'Z');
      this.dialogRef.close([this.selectedActivity, dateTime] as [string, Date]);
    }
  }
}
